jQuery(document).ready(function($) {
    $(".template-product .product__info-wrapper .product-form__controls-group input.hidden, .template-product .product__info-wrapper .product-form__controls-group label.hidden").removeClass('hidden');
    $('li.list-menu__item.facets__item input[value="Hidden"]').parent().hide();
    //   $("input[type='radio']").on("click", function () {
    //     var value = $(this).val(); // Get the clicked radio's value

    //     // Find all radio buttons with the same value and check them (excluding the clicked one)
    //     $("input[type='radio'][value='" + value + "']").not(this).prop("checked", true);
    // });
});

document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (event) {
        if (!(event.target instanceof Element)) return;

        const button = event.target.closest(".checkoutBtnDirect");
        if (!button) return;

        event.preventDefault();

        if (button.disabled || button.classList.contains("disabled") || button.getAttribute("aria-disabled") === "true") {
            return;
        }

        const form = button.closest("form");
        const variantInput = form ? form.querySelector("input[name='id']") : null;

        if (!form || !variantInput || variantInput.disabled || !variantInput.value) {
            console.error("Direct checkout could not find an available product variant.");
            return;
        }

        const quantityInput = form.querySelector(".quantity__input, input[name='quantity']");
        const quantity = quantityInput && quantityInput.value ? quantityInput.value : 1;
        const originalText = button.innerHTML;

        button.classList.add("disabled");
        button.setAttribute("aria-disabled", "true");
        button.innerHTML = "Adding to cart...";

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: variantInput.value,
                quantity: quantity
            })
        })
        .then(response => {
            return response.json().catch(() => ({})).then(data => {
                if (!response.ok || data.status) {
                    throw new Error(data.description || data.message || "Unable to add this product to cart.");
                }

                return data;
            });
        })
        .then(() => {
            window.location.href = "/checkout";
        })
        .catch(error => {
            console.error("Error adding to cart:", error);
            button.classList.remove("disabled");
            button.removeAttribute("aria-disabled");
            button.innerHTML = originalText;
        });
    });
//   $(document).ready(function () {
//     $("input[type='radio']").on("click", function () {
//         var value = $(this).val(); // Get the clicked radio's value

//         // Find all radio buttons with the same value and check them (excluding the clicked one)
//         $("input[type='radio'][value='" + value + "']").not(this).prop("checked", true);
//     });
// });
let isTaskCompleted = false; // Flag to track completion

// Function to sync the floated input when the page loads
function syncCheckedInputOnLoad() {
    // Find all checked radio inputs that start with 'template'
    $('input[type="radio"][id^="template"]:checked').each(function() {
        const value = $(this).val();
        const name = $(this).attr('name');
        
        // Find the corresponding floated input with the same value and name
        const floatedId = this.id.replace('template', 'floated-template');
        const $floatedInput = $('#' + floatedId);
        
        if ($floatedInput.length && !$floatedInput.is(':checked')) {
            $floatedInput.prop('checked', true);
            $floatedInput.prev().click();
            
            // Also trigger any change events if needed
            $floatedInput.trigger('change');
        }
    });
}

// Run the sync function when the page loads
$(document).ready(function() {
    // Initial sync
    syncCheckedInputOnLoad();
    
    // Also run it after a short delay in case floated inputs load later
    setTimeout(syncCheckedInputOnLoad, 500);
});

$(document).on('click', 'label[for^="template"], label[for^="floated-template"]', function (e) {
    if (isTaskCompleted) return; // If the task is already completed, stop further execution.

    const clickedLabelFor = $(this).attr('for');
    const $clickedInput = $('#' + clickedLabelFor);

    if ($clickedInput.length > 0) {
        // Prevent re-executing the task again.
        isTaskCompleted = true;

        // Store the current scroll position
        const scrollPosition = $(window).scrollTop();

        // Let Shopify handle the click normally
        setTimeout(function () {
            const inputVal = $.escapeSelector($clickedInput.val());


            // Find the "sibling" input (different id but same value)
            $('input[type="radio"][value="' + inputVal + '"]').each(function () {
                if (this.id !== clickedLabelFor) {
                    // Click its label (to preserve original logic)
                    $('label[for="' + this.id + '"]').trigger('click');
                }
            });

            // Restore the scroll position after the click is processed
            $(window).scrollTop(scrollPosition);

            // After execution, reset the flag for future actions (if needed).
            isTaskCompleted = false;
        }, 0);
    }
});


// Create a MutationObserver to detect when `.agrs__badge` is added to the DOM
let observerNew = new MutationObserver(function(mutationsList, observer) {
    let reviewWidget = $('.agrs__badge').first(); // Get the first element with the class '.agrs__badge'

    if (reviewWidget.length > 0) {
        $('#googleWidgetCatcher').append(reviewWidget); // Append it to '#googleWidgetCatcher'
        observer.disconnect(); // Stop observing after the element is appended
    }
});

// Configure the observer to watch for changes in the DOM
observerNew.observe(document.body, {
    childList: true,
    subtree: true
});


});
